<template>
  <!-- 兑换码 -->
  <div class="el-card pd20">
    <div class="main">
      <div class="el-card pd20 search">
        <div class="search-box">
          <!-- 测评名称 -->
          <el-input class="input" v-model="name" @keyup.enter.native="pullData()" placeholder="请输入兑换码名称"></el-input>
          <el-button type="primary" class="btn" @click="pullData()" size="small">查 询</el-button>
        </div>
      </div>
      <!-- list-->
      <div class="el-card pd20">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="name" label="兑换码名称"></el-table-column>
          <el-table-column prop="product" label="关联测评商品"> </el-table-column>
          <el-table-column prop="count" label="兑换码数量"></el-table-column>
          <el-table-column prop="use_count" label="已使用数量"></el-table-column>
          <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                  <el-button type="primary" size="mini"  @click="usageLogHandle(scope.$index, scope.row,'edit')" >使用记录</el-button>
                  <el-button type="danger" size="mini"  @click="failureHandle(scope.$index, scope.row)" >失效</el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加按钮 -->
      <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="addRedeemCode()" circle></el-button>
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
      <!-- -->
      <!-- <div class="pages-box"></div>  -->
    </div>
  </div>
</template>
<script>
import { codeList,exportCodeuseList,disableCode } from "@/api/measurement";
import { exportExcel } from "@u/tools";
export default {
  data() {
      return {
        list: [],
        pages: {},
        name:'',
        obj: {}
      }
    },
    methods: {
      /*
         *@param: 
         *@return: 
         *@Description: 使用记录
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 13:44:02
        */
        usageLogHandle(index,row){
            this.$router.push({
                path:'/main/redeem_code_details',
                query:{
                    group_id:row.id
                }
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 确定要失效试用链接吗
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-18 13:26:26
        */
        failureHandle(index,row){
            this.$confirm('确认要失效吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                disableCode({
                    group_id:row.id
                }).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return false;
                    }
                    this.$notify({
                        title: '成功',
                        message: '试用链接已失效！',
                        type: 'success'
                    });
                });
            }).catch();
        },
      /*
       *@param: 
       *@return: 
       *@Description: 添加兑换码
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-30 10:16:31
      */
      addRedeemCode(){
        this.$router.push('/main/redeem_code_form');
      },
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      pullData() {
        this.$showLoading();
        this.obj = {
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        // 判断如果有值为真的情况下传参,否则不传
        if (this.name) {
          this.obj['name'] = this.name;
        }
        codeList(this.obj).then((data) => {
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.main {
  position: relative;
}

.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}


.pages {
  text-align: right;
  margin-top: 30px;
}

.pages-box {
  height: 32px;
  margin-top: 30px;
}

.preview {
  width: 300px;
  border-radius: 5px;
}

.box {
  margin-bottom: 20px;
}

.search {
  margin-bottom: 20px;
  .search-box {
    display: flex;
    align-items: center;
    label {
      font-size: 16px;
      color: #606266;
    }
    .on {
      margin: 0 80px;
    }
    .input {
      width: 500px;
    }
    .btn {
      margin-left: auto;
    }
  }
}

.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
</style>
<style lang="scss">
.buy-time {
  input {
    background-color: transparent !important;
    width: 60% !important;
  }
}

.buy-time.el-date-editor.el-input,
.buy-time.el-date-editor.el-input__inner {
  margin-left: 20px;
}
</style>
